module.exports = __webpack_public_path__ + "static/img/border_2.b93b2851.png";